import { USER_PROFILE_SUB_NAVIGATION_LIST } from '@/app/modules/LandingHeader/config';
import { appClientConfig } from '@/app/utils/appClientConfig';
import { LoggedInAvatar } from '@/modules/LandingHeaderV2/components/LoggedInAvatar/LoggedInAvatar';
import { NavDropdown } from '@/modules/LandingHeaderV2/components/NavDropdown/NavDropdown';
import { NavLink } from '@/modules/LandingHeaderV2/components/NavLink/NavLink';

import styles from './LoggedInActionButtons.module.scss';

export interface LoggedInActionButtonsProps {
  isSmallScreen: boolean;
  userInitials: string;
  givenName?: string;
}

export const LoggedInActionButtons = ({
  isSmallScreen,
  givenName,
  userInitials,
}: LoggedInActionButtonsProps) => {
  const labelText = `Hi ${givenName ?? 'Doctor'}`;
  const practitionerProfileUrl = appClientConfig.practitionerProfileUrl ?? '';
  return isSmallScreen ? (
    <NavLink
      label={
        <>
          <span>{labelText}</span> <LoggedInAvatar initials={userInitials} />
        </>
      }
      to={practitionerProfileUrl}
      userInitials={userInitials}
      className={styles.loggedInLink}
      testid="logged-in-action-buttons-dropdown-mobile"
    />
  ) : (
    <NavDropdown
      label={labelText}
      to={practitionerProfileUrl}
      subItems={USER_PROFILE_SUB_NAVIGATION_LIST}
      isLoggedInDropdown
      userInitials={userInitials}
      isSmallScreen={isSmallScreen}
      testid="logged-in-action-buttons-link-desktop"
    />
  );
};
